import _ from 'lodash';

export default function results(state = {}, action) {
    switch (action.type) {
    case 'SAVE_RESULT':
        return { ...state,
                [action.id]: {
                    id: action.id,
                    type: action.widgetType,
                    value: action.value,
                },
        };
    case 'DELETE_RESULT':
        return _.omit(state, [action.id]);
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/results_reducers.js